module.exports = __webpack_public_path__ + "img/huotoupiao-logo.6d48cabd.png";